var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_4328)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.083334,
    d: "M26.2117 5.42308C26.2117 2.42799 24.9977 0 23.5001 0C22.0026 0 20.7886 2.42799 20.7886 5.42308C20.7886 8.41816 22.0026 10.8462 23.5001 10.8462C24.9977 10.8462 26.2117 8.41816 26.2117 5.42308Z",
    fill: "#FF6961"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.166667,
    d: "M34.8868 9.20066C36.3844 6.60685 36.547 3.89714 35.2501 3.14837C33.9532 2.3996 31.6879 3.89531 30.1903 6.48912C28.6928 9.08294 28.5301 11.7926 29.827 12.5414C31.1239 13.2902 33.3893 11.7945 34.8868 9.20066Z",
    fill: "#FF6961"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M40.5106 16.8098C43.1044 15.3123 44.6001 13.0469 43.8514 11.75C43.1026 10.4531 40.3929 10.6157 37.7991 12.1133C35.2053 13.6108 33.7096 15.8762 34.4583 17.1731C35.2071 18.47 37.9168 18.3073 40.5106 16.8098Z",
    fill: "#FF6961"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333334,
    d: "M41.5769 26.2115C44.572 26.2115 47 24.9975 47 23.5C47 22.0024 44.572 20.7885 41.5769 20.7885C38.5818 20.7885 36.1538 22.0024 36.1538 23.5C36.1538 24.9975 38.5818 26.2115 41.5769 26.2115Z",
    fill: "#FF6961"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.416667,
    d: "M37.7995 34.8867C40.3933 36.3843 43.103 36.5469 43.8518 35.25C44.6005 33.9531 43.1048 31.6877 40.511 30.1902C37.9172 28.6927 35.2075 28.53 34.4587 29.8269C33.7099 31.1238 35.2056 33.3892 37.7995 34.8867Z",
    fill: "#FF6961"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.1901 40.5109C31.6876 43.1047 33.953 44.6004 35.2499 43.8516C36.5468 43.1028 36.3841 40.3931 34.8866 37.7993C33.3891 35.2055 31.1237 33.7098 29.8268 34.4586C28.5299 35.2073 28.6925 37.917 30.1901 40.5109Z",
    fill: "#FF6961"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.583334,
    d: "M20.7883 41.5769C20.7883 44.572 22.0023 47 23.4999 47C24.9974 47 26.2114 44.572 26.2114 41.5769C26.2114 38.5818 24.9974 36.1538 23.4999 36.1538C22.0023 36.1538 20.7883 38.5818 20.7883 41.5769Z",
    fill: "#FF6961"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.666667,
    d: "M12.1132 37.7993C10.6156 40.3932 10.453 43.1029 11.7499 43.8516C13.0468 44.6004 15.3121 43.1047 16.8097 40.5109C18.3072 37.9171 18.4699 35.2074 17.173 34.4586C15.8761 33.7098 13.6107 35.2055 12.1132 37.7993Z",
    fill: "#FF6961"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M6.48938 30.1902C3.89556 31.6877 2.39985 33.9531 3.14863 35.25C3.8974 36.5469 6.6071 36.3843 9.20092 34.8867C11.7947 33.3892 13.2904 31.1238 12.5417 29.8269C11.7929 28.53 9.0832 28.6927 6.48938 30.1902Z",
    fill: "#FF6961"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.833334,
    d: "M5.42308 20.7885C2.42799 20.7885 0 22.0025 0 23.5C0 24.9976 2.42799 26.2115 5.42308 26.2115C8.41816 26.2115 10.8462 24.9976 10.8462 23.5C10.8462 22.0025 8.41816 20.7885 5.42308 20.7885Z",
    fill: "#FF6961"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.916667,
    d: "M9.20054 12.1133C6.60672 10.6157 3.89702 10.4531 3.14825 11.75C2.39948 13.0469 3.89519 15.3123 6.489 16.8098C9.08282 18.3073 11.7925 18.47 12.5413 17.1731C13.2901 15.8762 11.7944 13.6108 9.20054 12.1133Z",
    fill: "#FF6961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8099 6.48913C15.3124 3.89532 13.047 2.39961 11.7501 3.14838C10.4532 3.89715 10.6159 6.60686 12.1134 9.20067C13.6109 11.7945 15.8763 13.2902 17.1732 12.5414C18.4701 11.7927 18.3075 9.08295 16.8099 6.48913Z",
    fill: "#FF6961"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_4328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.a5eb1a770c9c0884bf501d12aacc4877.svg";
export { ForwardRef as ReactComponent };